import { render, staticRenderFns } from "./dataOra.vue?vue&type=template&id=9267e026&"
import script from "./dataOra.vue?vue&type=script&lang=js&"
export * from "./dataOra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports